import "slick-carousel";
import helpers from "../utils/helpers";
import Common from "../modules/common";

const templateHome = {
  init: function () {
    templateHome.init_slider();
    templateHome.video();
    templateHome.quote.init();
    templateHome.init_testimonials();
    templateHome.partners();
  },

  init_slider: function () {
    $(".hero .slider").slick({
      rows: 0,
      infinite: false,
      arrows: false,
      dots: true,
      fade: true,
    });
  },

  video: function () {
    $(".advantages-video__inner").on("click", function () {
      var inner = $(this);
      var btn = $(".advantages-video__play");

      btn.fadeOut();
      var video_url = btn.data("video");
      var video =
        '<iframe src="' +
        video_url +
        '" width="500" height="350" allowfullscreen></iframe>';
      inner.append(video);
    });
  },

  quote: {
    animated: false,

    init: function () {
      this.numbers();
      $(window).on("scroll", templateHome.quote.numbers);
    },

    numbers: function () {
      if (!templateHome.quote.animated) {
        var block = $(".quote__blocks");
        // Check if element is visible
        if (block.length && helpers.isElementInViewport(block[0])) {
          templateHome.quote.animated = true;
          templateHome.quote.counter();
        }
      }
    },

    counter: function () {
      $(".count").each(function () {
        var text = $(this);
        var to = text.data("num");
        $({
          Counter: 0,
        }).animate(
          {
            Counter: to,
          },
          {
            duration: 1000,
            easing: "swing",
            step: function () {
              text.text(Math.ceil(this.Counter));
            },
          }
        );
      });
    },
  },

  init_testimonials: function () {
    $(".testimonials__slider").slick({
      rows: 0,
      infinite: false,
      dots: true,
      prevArrow: Common.prev_arrow,
      nextArrow: Common.next_arrow,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            arrows: false,
          },
        },
      ],
    });
  },
  partners: function () {
    var slider = $(".partners__slider");
    if (slider.length) {
      $(".partners__slider").slick({
        rows: 0,
        slidesToShow: 4,
        prevArrow: Common.prev_arrow,
        nextArrow: Common.next_arrow,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });
    }
  },
};

export default templateHome;
